import React, { FC } from "react";
import { Grid, Typography } from "@mui/material";
import { images } from "../../utils/constants/images";

const Banner: FC = () => {
  return (
    <Grid
      container
      justifyContent={"center"}
      sx={{
        backgroundImage: `linear-gradient(180deg,#2b87da 0%,rgba(0,0,0,0.49) 0%),url(${images.Background})`,
        backgroundSize: "cover",
        borderBottomLeftRadius: "200px",
        paddingY: "80px",
      }}
    >
      <Grid
        item
        xs={8}
        textAlign={"center"}
        sx={{ paddingTop: "80px", paddingBottom: "50px" }}
      >
        <img src={images.WhiteLogo} alt={"ICA-AP White Logo"} />
      </Grid>
      <Grid
        item
        xs={8}
        textAlign={"center"}
        sx={{ paddingTop: "50px", paddingBottom: "80px" }}
      >
        <Typography
          variant={"h1"}
          fontWeight={900}
          color={"#ffffff"}
          letterSpacing={"1px"}
          fontSize={30}
          lineHeight={"1.3em"}
        >
          16th ICA – AP Regional Assembly
        </Typography>
        <Typography
          variant={"h3"}
          fontWeight={700}
          color={"#ffffff"}
          letterSpacing={"1px"}
          fontSize={24}
          lineHeight={"1.3em"}
          sx={{ fontVariant: "small-caps" }}
        >
          Manila | Philippines
        </Typography>
        <Typography
          variant={"body1"}
          fontWeight={700}
          color={"#ffffff"}
          letterSpacing={"1px"}
        >
          6th – 10th Nov 2023
        </Typography>
      </Grid>
    </Grid>
  );
};

export default Banner;
